import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { QuestsContainer, H6QuestName } from './_Styled'
import LevelQuest from '../../../mini/LevelQuest/LevelQuest'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import QuestTooltipMentor from '../Tooltip/QuestTooltipMentor'
import { CoreChoiceMarker } from '../styles'
import { H5 } from '../../../styled/typography/typography'
import TooltipContainer from '../../../styled/TooltipContainer'
import ReactTooltip from 'react-tooltip'

const Wrapper = styled(FlexAlignCenter)`
  justify-content: flex-start;
  cursor: pointer;

  .icon-wrapper .icon {
    opacity: 1 !important;
  }
`

const LevelQuestsMentor = ({
  label,
  count,
  quests,
  handleQuestClick,
  courseColor,
  courseSectionId,
  isActivityCourse,
  orgId
}) => {
  const questItems = quests.map(updatedQuest => {
    return (
      <Wrapper key={`level-modal-quest-${updatedQuest.id}`}>
        <LevelQuest
          quest={updatedQuest}
          studentId={1}
          handleQuestClick={handleQuestClick}
          tooltipId={`level-modal-mentor-quest-tooltip-${updatedQuest.level_id}`}
          courseSectionId={courseSectionId}
        />
        <H6QuestName onClick={() => handleQuestClick({ quest: updatedQuest })}>
          {updatedQuest.name}
        </H6QuestName>
      </Wrapper>
    )
  })

  const getTooltipContent = dataTip => {
    const quest = quests.find(q => q.id === parseInt(dataTip))

    return quest ? (
      <QuestTooltipMentor
        quest={quest}
        unstarted={!quest.progress}
        awaitingFeedback={false}
        feedbackKeepWorking={false}
        feedbackContinue={false}
        questComplete={false}
        core={quest.required}
        progress={null}
        courseColor={courseColor}
        orgId={orgId}
      />
    ) : null
  }

  return (
    <QuestsContainer>
      {!isActivityCourse && (
        <FlexAlignCenter
          style={{ justifyContent: 'space-between', marginBottom: '6px' }}
        >
          <CoreChoiceMarker>{label}</CoreChoiceMarker>
          <H5 dove>{`${count} Minimum`}</H5>
        </FlexAlignCenter>
      )}
      {questItems}

      <TooltipContainer>
        <ReactTooltip
          id={`level-modal-mentor-quest-tooltip-${quests[0]?.level_id}`}
          effect="solid"
          getContent={getTooltipContent}
        />
      </TooltipContainer>
    </QuestsContainer>
  )
}

LevelQuestsMentor.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  quests: PropTypes.array.isRequired,
  handleQuestClick: PropTypes.func.isRequired,
  courseColor: PropTypes.string.isRequired
}

export default LevelQuestsMentor
